import { ConfigObj, CssModifiers, DomHelpers, FeatureDetection } from '../utils/'

const ERROR_CLASS = 'input-validation-error'
const defaultOpts = {}

export default class CustomSelect {

  constructor($el, opts) {
    this.$el = $el;
    this.options = ConfigObj.merge(defaultOpts, opts)
  }

  /**
   * Initializes the class
   */
  init() {
    const _$select = this.$el.querySelector('select')

    if (_$select == null) return console.error('No select element exists')

    this.$select = _$select

    this.setStateFromValue()
    this.addEventListeners()
  }


  /**
   * Sets the state of the dropdown depending on its value
  */
  setStateFromValue() {
    window.setTimeout(() => { // Set timeout here to ensure function picks up changed css class list
      const isInvalid = this.$select.classList.contains(ERROR_CLASS)
      const hasValue = Boolean(this.$select.value.length)

      CssModifiers.toggle(this.$el, isInvalid, 'm-invalid')
      CssModifiers.toggle(this.$el, hasValue, 'm-has-value')
    }, 0)
  }


  /**
   * check validity of field on form submit
   * @param {any} e
   */
  onFormClick(e) {
    const matchFn = FeatureDetection.browser.isIe11()
      ? 'msMatchesSelector'
      : 'matches'

    if (e.target[matchFn]('input[type="submit"]')) this.setStateFromValue()
  }


  /**
   * Actions to call when select has focus
   */
  onFocus() {
    CssModifiers.add(this.$el, 'm-focus')
  }


  /**
   * Actions to call when select loses focus
   */
  onBlur() {
    CssModifiers.remove(this.$el, 'm-focus')
  }

  /**
   * Binds event handlers to events
   */
  addEventListeners() {
    const $form = DomHelpers.getParentNode(this.$select, 'form')
    if ($form != null) $form.addEventListener('click', this.onFormClick.bind(this))

    this.$select.addEventListener('change', this.setStateFromValue.bind(this))
    this.$select.addEventListener('focus', this.onFocus.bind(this))
    this.$select.addEventListener('blur', this.onBlur.bind(this))
  }
}



// WEBPACK FOOTER //
// ./js/modules/CustomSelect.js